import { Phone, MapPin, Clock, Instagram, Facebook } from "lucide-react";
import { shop, social } from "../../data";

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18" aria-hidden="true" {...props}>
    <path d="M16.6 5.82s.51.5 0 0A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 0 1-2.59 2.5c-1.42 0-2.6-1.16-2.6-2.6 0-1.72 1.66-3.01 3.37-2.48V9.66c-3.45-.46-6.47 2.22-6.47 5.64 0 3.33 2.76 5.7 5.69 5.7 3.14 0 5.69-2.55 5.69-5.7V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3s-1.88.09-3.34-1.48z"/>
  </svg>
);

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#123D5B] text-[#FCFAFB] pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 pb-14 border-b border-white/10">
          <div>
            <img
              src="/logo.jpg"
              alt="La casa del pigiama"
              className="h-24 w-24 object-contain rounded-2xl bg-white p-1.5 mb-5"
            />
            <p className="font-serif text-3xl">La casa del pigiama</p>
            <p className="text-[10px] tracking-[0.3em] uppercase text-[#F2A0B4] mt-2">
              Novara · dal cuore della città
            </p>
            <p className="text-white/60 text-sm mt-5 leading-relaxed max-w-xs">
              Pigiami, camicie da notte, vestaglie e intimo per tutte le età.
              Ampia scelta, prezzi bassi e accoglienza sincera.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a
                href={social.instagram}
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                data-testid="social-instagram"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#F2A0B4] hover:text-[#123D5B] flex items-center justify-center transition-all duration-300 hover:-translate-y-1"
              >
                <Instagram size={18} aria-hidden="true" />
              </a>
              <a
                href={social.tiktok}
                target="_blank"
                rel="noreferrer"
                aria-label="TikTok"
                data-testid="social-tiktok"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#F2A0B4] hover:text-[#123D5B] flex items-center justify-center transition-all duration-300 hover:-translate-y-1"
              >
                <TikTokIcon />
              </a>
              <a
                href={social.facebook}
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
                data-testid="social-facebook"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#F2A0B4] hover:text-[#123D5B] flex items-center justify-center transition-all duration-300 hover:-translate-y-1"
              >
                <Facebook size={18} aria-hidden="true" />
              </a>
            </div>
          </div>

          <div className="space-y-4 text-sm">
            <p className="text-xs tracking-[0.2em] uppercase text-[#F2A0B4] mb-4">
              Contatti
            </p>
            <p className="flex gap-3 text-white/75">
              <MapPin size={17} className="shrink-0 mt-0.5 text-[#F2A0B4]" aria-hidden="true" />
              {shop.address}
            </p>
            <a href={shop.phoneHref} className="flex gap-3 text-white/75 hover:text-white transition-colors">
              <Phone size={17} className="shrink-0 mt-0.5 text-[#F2A0B4]" aria-hidden="true" />
              {shop.phone}
            </a>
            <p className="flex gap-3 text-white/75">
              <Clock size={17} className="shrink-0 mt-0.5 text-[#F2A0B4]" aria-hidden="true" />
              Lun–Sab · 09:00–13:30 e 15:00–19:30
            </p>
          </div>

          <div className="space-y-3 text-sm">
            <p className="text-xs tracking-[0.2em] uppercase text-[#F2A0B4] mb-4">
              Naviga
            </p>
            <a href="/#about" className="block text-white/75 hover:text-white transition-colors">Il Negozio</a>
            <a href="/#categorie" className="block text-white/75 hover:text-white transition-colors">Collezioni</a>
            <a href="/#recensioni" className="block text-white/75 hover:text-white transition-colors">Recensioni</a>
            <a href="/#contatti" className="block text-white/75 hover:text-white transition-colors">Contatti</a>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/40">
          <p>© {new Date().getFullYear()} La casa del pigiama · {shop.province} · P. IVA 02570480034</p>
          <p>Realizzato con cura per il commercio locale.</p>
        </div>
      </div>
    </footer>
  );
}
